import ObjectFitImages from "object-fit-images";

$(document).ready(() => {
  ObjectFitImages();
});
